<template lang="pug">
    div
        PmNavbarMobile
        PmNavbar
        transition(name="fade", mode="out-in", @beforeLeave="beforeLeave", @enter="enter", @afterEnter="afterEnter")
            router-view(:key="$route.fullPath")
        PmFooter
</template>

<script>
import PmNavbar from '../molecules/PmNavbar.vue'
import PmFooter from '../molecules/PmFooter.vue'
import PmHome from '../organisms/PmHome.vue'
import PmNavbarMobile from '../molecules/PmNavbarMobile.vue'

export default {
    components: {
        PmNavbar, PmHome, PmFooter, PmNavbarMobile
    },
    methods: {
        beforeLeave(element) {
            this.prevHeight = getComputedStyle(element).height;
        },
        enter(element) {
            const { height } = getComputedStyle(element);

            element.style.height = this.prevHeight;

            setTimeout(() => {
                element.style.height = height;
            });
        },
        afterEnter(element) {
            element.style.height = 'auto';  
        }
    }
}
</script>

<style lang="scss">
    @import '../../assets/css/app.css';
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: height, opacity;
        transition-timing-function: ease;
        overflow: hidden;
    }

    .fade-enter,
    .fade-leave-active {
    opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/components/ecosystems/App.vue